export const leaveHolidayConstants = {
    GET_HOLIDAY_LIST: "GET_HOLIDAY_LIST",
    GET_HOLIDAY_LIST_PAGE: "GET_HOLIDAY_LIST_PAGE",
    GET_HOLIDAY_LIST_SUCCESS: "GET_HOLIDAY_LIST_SUCCESS",
    CREATE_HOLIDAY: "CREATE_HOLIDAY",
    CREATE_HOLIDAY_SUCCESS: "CREATE_HOLIDAY_SUCCESS",
    CREATE_HOLIDAY_FAIL: "CREATE_HOLIDAY_FAIL",
    DELETE_HOLIDAY: "DELETE_HOLIDAY",
    DELETE_HOLIDAY_SUCCESS: "DELETE_HOLIDAY_SUCCESS",
    DELETE_HOLIDAY_FAIL: "DELETE_HOLIDAY_FAIL",
    UPDATE_HOLIDAY: "UPDATE_HOLIDAY",
    UPDATE_HOLIDAY_SUCCESS: "UPDATE_HOLIDAY_SUCCESS",
    UPDATE_HOLIDAY_FAIL: "UPDATE_HOLIDAY_FAIL",
    CLEAR_MESSAGE: "CLEAR_MESSAGE",
};

export const holidayType = {
    1: "Company day-off",
    2: "Holiday",
    3: "Compensation day",
};

export const colorArrayHoliday = {
    1: "#ffffc3",
    2: "#ec7c6d",
    3: "#c3bbf6",
};
